import React, { PropsWithChildren } from 'react';

import { bm } from '@skippay/core/utils/classUtils';

import './index.sass';

const MODULE_NAME = 'Headline';

interface Props {
	center?: boolean;
	classes?: string;
	colorBase?: boolean;
	colorInverted?: boolean;
	colorSecondary?: boolean;
	component?: React.ElementType;

	xs?: boolean;
	sm?: boolean;
	md?: boolean;
	mdSm?: boolean;
	mdLg?: boolean;
	lg?: boolean;
	xl?: boolean;
	xlg?: boolean;

	mobBase?: boolean;
	mobSm?: boolean;
	mobMd?: boolean;
	mobLg?: boolean;
	id?: string;

	weight?: 'medium' | 'thin';
}

function Headline(props: PropsWithChildren<Props>): JSX.Element {
	const {
		center: textCenter,
		children,
		classes,
		colorBase,
		colorInverted,
		colorSecondary,
		component: Component = 'span',
		lg,
		md,
		mdLg,
		mdSm,
		sm,
		xl,
		xlg,
		xs,
		mobBase,
		mobSm,
		mobMd,
		mobLg,
		weight,
		id,
	} = props;
	return (
		<Component
			id={id}
			className={bm(
				MODULE_NAME,
				{
					xs,
					sm,
					lg,
					md,
					mdLg,
					mdSm,
					xl,
					medium: weight === 'medium',
					xlg,
					thin: weight === 'thin',
					mobBase,
					mobSm,
					mobMd,
					mobLg,
				},
				[
					textCenter && 'textCenter',
					colorInverted && 'colorInverted',
					colorSecondary && 'colorSecondary',
					colorBase && 'colorBase',
					classes,
				]
			)}
		>
			{children}
		</Component>
	);
}

export default Headline;
